package org.gstechnovos.jexonplastech.sections.about.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px

val CapabilitiesContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            // Alternating background color for visual separation
            .backgroundColor(palette.custom.lightGray)
    }
}

val CapabilityItemStyle = CssStyle {
    base {
        Modifier.fillMaxWidth()
    }
}